import { reportTelemetryOnce } from "@coworker/common/helpers/sentry.helpers";

export const isImageValid = (file: File): Promise<boolean> => {
  if (file.size === 0) {
    return Promise.resolve(false);
  }

  return new Promise((resolve) => {
    const img = new window.Image();
    let objectUrl: string;

    try {
      objectUrl = URL.createObjectURL(file);
    } catch (error) {
      reportTelemetryOnce(
        `add-images:object-url-create-failed:${file.type || "unknown"}`,
        "Failed to create object URL during image validation",
        {
          fileName: file.name,
          fileSize: file.size,
          fileType: file.type,
          error: String(error),
        }
      );
      resolve(false);
      return;
    }

    img.onload = () => {
      URL.revokeObjectURL(objectUrl);
      resolve(true);
    };
    img.onerror = () => {
      URL.revokeObjectURL(objectUrl);
      resolve(false);
    };

    try {
      img.src = objectUrl;
    } catch (error) {
      reportTelemetryOnce(
        `add-images:set-image-src-failed:${file.type || "unknown"}`,
        "Failed to set image src during image validation",
        {
          fileName: file.name,
          fileSize: file.size,
          fileType: file.type,
          error: String(error),
        }
      );
      URL.revokeObjectURL(objectUrl);
      resolve(false);
    }
  });
};
